import { Masonry } from "@mui/lab"
import { Box } from "@mui/material"

import BlogArticleTeaser, {
  type BlogArticleTeaserProps,
} from "../BlogArticleTeaser/BlogArticleTeaser"

import { Container, Pagination, type FC } from ".."

type PressCentreArticleProps = Omit<BlogArticleTeaserProps, "author" | "tags">

type PressCentreListProps = {
  pageCount?: number
  items: PressCentreArticleProps[]
  onPageChange?: (pageNumber: number) => void
}

const PressCentreList: FC<PressCentreListProps> = ({ pageCount, items = [], onPageChange }) => {
  return (
    <Container>
      <PressCentreCollection items={items} />
      <Box pt={15} pb={{ xs: 15, md: 11 }}>
        <Pagination page={1} count={pageCount} onPageChange={onPageChange as () => void} />
      </Box>
    </Container>
  )
}
export default PressCentreList

const PressCentreCollection: FC<PressCentreListProps> = ({ items = [] }) => {
  return (
    <Box m={{ xs: -2, md: -5 }}>
      <Masonry columns={{ xs: 1, md: 2, xl: 3 }}>
        {items?.map((item, i) => (
          <Box key={i} p={{ xs: 2, md: 5 }}>
            <BlogArticleTeaser
              {...item}
              type="press"
              tags={[{ label: "Press Centre", color: "floralWhite", uri: "#", autoWidth: true }]}
            />
          </Box>
        ))}
      </Masonry>
    </Box>
  )
}
